import {
  cancelBudgetTemplate,
  getBudgetTemplateList,
  getBudgetTemplatePreview,
  getDeptDefaultProject,
  publishBudgetTemplate,
  saveBudgetTemplate,
} from '../services';

export default {
  namespace: 'budgetTemplate',
  state: {
    assistedReportControl: undefined,
  },
  effects: {
    // 获取预算填报模板
    *getBudgetTemplateList({ payload }, { call }) {
      return yield call(getBudgetTemplateList, payload);
    },

    // 获取预算填报模板
    *getBudgetTemplatePreview({ payload }, { call }) {
      return yield call(getBudgetTemplatePreview, payload);
    },

    // 保存预算填报模板
    *saveBudgetTemplate({ payload }, { call }) {
      return yield call(saveBudgetTemplate, payload);
    },

    // 下发预算填报模板
    *publishBudgetTemplate({ payload }, { call }) {
      return yield call(publishBudgetTemplate, payload);
    },
    // 撤回预算填报模板
    *cancelBudgetTemplate({ payload }, { call }) {
      return yield call(cancelBudgetTemplate, payload);
    },
    // 获取部门的默认项目
    *getDeptDefaultProject({ payload }, { call }) {
      return yield call(getDeptDefaultProject, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
